import { Component, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'client-sign-stock-thanks',
  templateUrl: './client-sign-stock-thanks.component.html',
  styleUrls: ['./client-sign-stock-thanks.component.scss'],
})
export class ClientSignStockThanksComponent {
  @Input() isDirectOrder: boolean = false;

  constructor(public dialogRef: MatDialogRef<ClientSignStockThanksComponent>) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
